module.exports = __webpack_public_path__ + "static/media/slide1-sk.a7279c34.webp";